import { atom } from 'jotai';
/**
 * 再度メニュー状態
 */
export type NavbarStateType = {
  open: boolean;
};

export const NavbarState = atom<NavbarStateType>({
  open: false,
});
